// Keys used for redirect
export const LS_ROUTE_KEY = 'ROUTE_KEY'
export const LS_ROUTE_PARAMS = 'ROUTE_PARAMS'
export const LS_ROUTE_QUERY = 'ROUTE_QUERY'
export const LS_ROUTE_EXPIRED_SESSION = 'ROUTE_EXPIRED_SESSION'

// Set when an authenticated session ends on its own (401 or a failed refresh), read and
// cleared by the login page to show the "logged out after inactivity" notice
export const LS_SESSION_EXPIRED_NOTICE = 'SESSION_EXPIRED_NOTICE'

export const LAST_USER = 'LAST_USER'
